import NoResults from "../../search-results/components/NoResults";

import { Configure, Index, useHits, useInstantSearch, useSearchBox } from "react-instantsearch";
import { Article, ArticleHit } from "../../search-results/article";
import { ArticleCardSkeleton } from "../../search-results/components/ArticleCardSkeleton";
import { ArticleCard } from "../../search-results/components/ArticleCard";
import ShowAllResultsButton from "../../components/ShowAllResultsButton";
import { useIndexName } from "../../search-results/components/IndexNameProvider";
import { searchIndexes } from "../../search-shared/client";
import { VirtualSearchBox } from "../../search-shared/VirtualSearchBox";

function ArticleHitsContent() {
    const { status } = useInstantSearch();
    const { items } = useHits<Article>();

    const onSelect = (hit: ArticleHit) => {
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/blogs/${hit.blog.handle}/${hit.handle}`;
    }

    const onShowAll = () => {
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/blogs/${items[0]?.blog.handle || "news"}`;
    }

    return (
        <>
            <div className="tw-space-y-3">
                {((status === "loading" || status === "stalled")) &&
                    Array(4).fill(null).map((_, index) => <ArticleCardSkeleton key={index} />)
                }
                {(status === "idle") && items.length > 0 ?
                    items.map((item) => <ArticleCard key={item.objectID} onSelect={onSelect} articleHit={item} layout="horizontal" />)
                    : <NoResults />}
            </div>

            {items.length > 0 && (
                <ShowAllResultsButton onClick={onShowAll} text="See all articles" className="tw-py-20" />
            )}
        </>
    )
}

export default function ArticleHits() {
    const { articles_autocomplete_hits_per_page = 6 } = window.algoliaShopify.config;
    const { query } = useSearchBox();
    const { indexName: currentIndex } = useIndexName();

    return (
        <Index indexName={searchIndexes.ARTICLES}>
            <VirtualSearchBox />
            <Configure
                hitsPerPage={articles_autocomplete_hits_per_page}
                query={query}
            />

            {currentIndex === searchIndexes.ARTICLES &&
                <ArticleHitsContent />
            }
        </Index>
    )
}